import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function OfferStack() {
  const items = [{
    name: 'Método Energía Real – 6 tomos paso a paso',
    value: '$35.000'
  }, {
    name: 'Bono 1 – Plan Calma sin Culpa',
    value: '$9.000'
  }, {
    name: 'Bono 2 – Mapa de Fugas Energéticas Invisibles',
    value: '$12.000'
  }, {
    name: 'Bono 3 – Guía "Cuando todo pesa"',
    value: '$8.000'
  }];
  const frictionReducers = ['Pago único', 'Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días'];
  return <Section background="gradient-purple" containerSize="md" className="text-center" data-id="element-265">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="bg-cream p-10 md:p-16 rounded-[3rem] shadow-sm border border-dusty-rose/30 max-w-3xl mx-auto" data-id="element-266">
        {/* Valor acumulado */}
        <h2 className="text-3xl md:text-4xl font-serif italic text-navy mb-12" data-id="element-267">
          Todo lo que incluye el Pack Premium
        </h2>

        <div className="space-y-6 mb-12 max-w-lg mx-auto" data-id="element-268">
          {items.map((item, i) => <motion.div key={i} className="flex items-start gap-4 text-left" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} viewport={{
          once: true
        }} data-id="element-269">
              <div className="bg-warm-gold/10 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-270">
                <Check className="w-4 h-4 text-warm-gold" data-id="element-271" />
              </div>
              <div className="flex-1" data-id="element-272">
                <p className="text-base md:text-lg font-light text-navy leading-snug" data-id="element-273">
                  {item.name}
                </p>
                <p className="text-xs text-muted font-light mt-1" data-id="element-274">
                  Valor estimado: {item.value}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Separador */}
        <div className="border-t border-dusty-rose/20 my-10 max-w-sm mx-auto" data-id="element-275" />

        {/* Precio */}
        <div className="mb-4" data-id="element-276">
          <p className="text-xs font-bold text-dusty-rose mb-2 uppercase tracking-widest" data-id="element-277">
            Valor total real
          </p>
          <span className="text-2xl text-mauve/60 line-through font-light" data-id="element-278">
            $64.000 ARS
          </span>
        </div>

        <div className="mb-6" data-id="element-279">
          <p className="text-sm font-medium text-navy mb-2" data-id="element-280">
            Hoy acceso completo por lanzamiento:
          </p>
          <span className="text-6xl md:text-7xl font-serif italic text-warm-gold" data-id="element-281">
            $12.999
          </span>
          <span className="text-2xl font-light text-warm-gold/70 ml-2" data-id="element-282">
            ARS
          </span>
        </div>

        <p className="text-sm italic text-muted font-light mb-8" data-id="element-283">
          Precio especial de lanzamiento extendido por tiempo limitado.
        </p>

        <motion.span className="inline-block text-white font-medium bg-warm-gold px-6 py-2 rounded-full text-sm mb-10 shadow-sm shadow-warm-gold/20" initial={{
        scale: 0.95
      }} whileInView={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        delay: 0.4
      }} viewport={{
        once: true
      }} data-id="element-284">
          Ahorrás $51.001 ARS
        </motion.span>

        {/* Friction reducers */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-10" data-id="element-285">
          {frictionReducers.map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-muted font-light" data-id="element-286">
              <Check className="w-4 h-4 text-warm-gold/70" data-id="element-287" />
              <span data-id="element-288">{item}</span>
            </div>)}
        </div>

        {/* Comparación invisible */}
        <p className="text-base italic text-navy/70 mb-10 max-w-md mx-auto font-serif" data-id="element-289">
          "Mucho menos que una sesión de terapia. Mucho menos que seguir agotada
          meses más."
        </p>

        <Button href="https://checkout.infinita-mente.online/checkouts/cn/hWN9k9IdvMh4a0eyG3Ib72tF/es-ar?_r=AQABuGfEX37MTkCup0Rq8tDOnVM70xe0iNj_Nsvx1rNaHiU&preview_theme_id=138558668898" external variant="vibrant" size="xxl" fullWidth className="mb-6" data-id="element-290">
          QUIERO MI ACCESO INMEDIATO
        </Button>

        <p className="text-xs font-light text-muted tracking-widest uppercase" data-id="element-291">
          Acceso inmediato · Producto digital · Garantía 7 días
        </p>
      </motion.div>
    </Section>;
}